import { RecurringDocumentKind, RecurringDocumentMode } from '../../interfaces/recurringDocument.interface';
import { firstOccurrence } from '../accounting/recurringJournalText';

export const KIND_LABEL: Record<RecurringDocumentKind, string> = {
  SALES_INVOICE: 'Invoice',
  QUOTATION: 'Quotation',
  SUPPLIER_BILL: 'Supplier bill',
};

export const MODES: Record<RecurringDocumentKind, { value: RecurringDocumentMode; label: string }[]> = {
  SALES_INVOICE: [
    { value: 'DRAFT', label: 'Leave a draft for review' },
    { value: 'ISSUE', label: 'Issue (numbered, not e-mailed)' },
  ],
  QUOTATION: [
    { value: 'DRAFT', label: 'Leave a draft for review' },
    { value: 'SEND', label: 'Mark as sent (not e-mailed)' },
  ],
  SUPPLIER_BILL: [
    { value: 'POST', label: 'Create and post the bill' },
    { value: 'REVIEW', label: 'Wait for a person to create the bill' },
  ],
};

export const modeLabel = (kind: RecurringDocumentKind, mode: RecurringDocumentMode): string =>
  MODES[kind].find(m => m.value === mode)?.label ?? mode;

const iso = (y: number, m: number, d: number) => `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

/** Client copy of the server schedule rules, for the "next dates" preview only; the server decides. */
export const nextDates = (
  frequency: string, intervalCount: number, dayOfMonth: number | null, lastDay: boolean, start: string, count = 3,
): string[] => {
  if (!start) return [];
  const n = Math.max(1, intervalCount || 1);
  let cur = firstOccurrence(frequency, dayOfMonth, lastDay, start);
  const out: string[] = [];
  const stepMonths = frequency === 'MONTHLY' ? n : frequency === 'QUARTERLY' ? 3 * n : 12 * n;
  for (let i = 0; i < count; i++) {
    out.push(cur);
    let [y, m, d] = cur.split('-').map(Number);
    if (frequency === 'WEEKLY') {
      const dt = new Date(Date.UTC(y, m - 1, d + 7 * n));
      cur = iso(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
    } else {
      const total = y * 12 + (m - 1) + stepMonths;
      y = Math.floor(total / 12); m = (total % 12) + 1;
      d = lastDay ? new Date(Date.UTC(y, m, 0)).getUTCDate() : (dayOfMonth ?? d);
      cur = iso(y, m, d);
    }
  }
  return out;
};
